import { useEffect, useState } from 'react';
import { useAuthStore } from '@/website/store/AuthStore';
import { getCurrentUserPortalInfo } from '@jove-frontend/uikit';

export const useUserPortal = () => {
  const [userPortalList, setUserPortalList] = useState([]);
  const {
    state: { user, userRoles },
  } = useAuthStore();

  /**
   * effects
   */
  useEffect(() => {
    if (userRoles || user) {
      const portalInfo = getCurrentUserPortalInfo(user, userRoles);
      portalInfo.portalList = portalInfo.portalList.filter((item) => item.value !== 'community-user');
      setUserPortalList(portalInfo.portalList);
    }
  }, [user, userRoles]);

  return {
    userPortalList,
  };
};
